import type { I18n, MessageDescriptor } from '@lingui/core';
import { msg, t } from '@lingui/core/macro';
import type { AgentRuntimeReason, AgentRuntimeState } from './api';

export interface AgentStateLabel {
  text: string;
  tone: 'ok' | 'muted' | 'error';
}

export const REASON_LABELS: Record<AgentRuntimeReason, MessageDescriptor> = {
  api_key_invalid: msg`Invalid API key`,
  quota_exceeded: msg`Quota exceeded`,
  network_unreachable: msg`Network unreachable`,
  runtime_crashed: msg`Runtime crashed`,
  runtime_timeout: msg`Runtime timed out`,
  unknown: msg`Unknown error`,
};

export const DISABLED_LABEL = msg`Disabled`;

export function describeAgentState(
  state: AgentRuntimeState | undefined,
  reason: AgentRuntimeReason | undefined,
  i18n: I18n,
): AgentStateLabel {
  if (state === 'online') return { text: t(i18n)`Online`, tone: 'ok' };
  if (state === 'error') {
    const reasonText = i18n._(
      reason && Object.hasOwn(REASON_LABELS, reason)
        ? REASON_LABELS[reason]
        : REASON_LABELS.unknown,
    );
    return { text: t(i18n)`Error (${reasonText})`, tone: 'error' };
  }
  if (state === 'busy') return { text: t(i18n)`Working`, tone: 'ok' };
  if (state === 'idle') return { text: t(i18n)`Idle`, tone: 'muted' };
  return { text: t(i18n)`Offline`, tone: 'muted' };
}
